import React, { useEffect, useState } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import { BarChart } from "@mui/x-charts"
import { trans } from "@/_providers/Translation"

const COLORS = {
  household: "#3B82F6",
  corporate: "#8B5CF6",
}

export default function CLVBySegments() {
  const [loading, setLoading] = useState(true)
  const [chartData, setChartData] = useState(null)

  useEffect(() => {
    Api.get("analytics/clv-by-segments")
      .then((res) => {
        setChartData(res.data?.chart_data ?? null)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  const labels = chartData?.labels ?? []
  const household = chartData?.household ?? []
  const corporate = chartData?.corporate ?? []
  const legend = chartData?.legend ?? ["Домакинства", "Корпоративни"]

  const dataset = labels.map((year, i) => ({
    year: String(year),
    household: household[i] ?? 0,
    corporate: corporate[i] ?? 0,
  }))

  const hasData = dataset.some((d) => d.household > 0 || d.corporate > 0)

  return (
    <div className="clv-by-segment-chart">
      <div className="head">
        <h3>{trans("analytics.clvBySegment")}</h3>
        <div className="right">
          <ul>
            <li>
              <span style={{ backgroundColor: COLORS.household }} />
              {legend[0]}
            </li>
            <li>
              <span style={{ backgroundColor: COLORS.corporate }} />
              {legend[1]}
            </li>
          </ul>
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !hasData ? (
        <div className="alert info" style={{ marginBottom: 0, width: "100%" }}>
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <BarChart
          dataset={dataset}
          xAxis={[{ scaleType: "band", dataKey: "year" }]}
          series={[
            {
              dataKey: "household",
              label: legend[0],
              color: COLORS.household,
              valueFormatter: (v) => String(v),
            },
            {
              dataKey: "corporate",
              label: legend[1],
              color: COLORS.corporate,
              valueFormatter: (v) => String(v),
            },
          ]}
          height={400}
          margin={{ right: 0 }}
          slotProps={{ legend: { hidden: true } }}
          borderRadius={4}
        />
      )}
    </div>
  )
}

